
export const PAGE_INDIVIDUAL_ON_EXCHANGE_PLAN_ENROLLMENT_PAYMENT = 'PAGE_INDIVIDUAL_ON_EXCHANGE_PLAN_ENROLLMENT_PAYMENT';
export enum PAGE_INDIVIDUAL_ON_EXCHANGE_PLAN_ENROLLMENT_PAYMENT_KEYS {
  APPLICATION_STATUS_URL = 'APPLICATION_STATUS_URL',
  LOGIN_IMAGE = 'LOGIN_IMAGE',
  CONTINUE_IMAGE = 'CONTINUE_IMAGE',
  APP_SELECTION_IMAGE = 'APP_SELECTION_IMAGE',
  PREMIUM_PAYMENT_IMAGE = 'PREMIUM_PAYMENT_IMAGE'
}
